import {
  TrustpilotRoot,
  ReviewsWrapper,
  TrustpilotContent,
  TrustpilotContainer,
} from './TrustpilotSection.styles'
import { Trustpilot } from 'features/components/Trustpilot'

export const TrustpilotSection = () => {
  return (
    <TrustpilotRoot>
      <TrustpilotContainer>
        <ReviewsWrapper>
          <TrustpilotContent>
            <Trustpilot dataTemplateId="5419b6ffb0d04a076446a9af" theme="light" />
          </TrustpilotContent>
        </ReviewsWrapper>
      </TrustpilotContainer>
    </TrustpilotRoot>
  )
}
